
/* eslint-disable no-nested-ternary , no-unused-expressions */ 

import React, { useState, useEffect, useMemo } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { Container } from '@material-ui/core';

import styles from './View.Style';

import IdeaPanel from '../../components_newui/idea_panel/View';
import Breadcrumbs from 'components_newui/pageBreadcrumbsMenu/View';
import noIdeasImg from 'img/no_ideas.png';
import statusConstants from 'common_constants/idea_states_constants';
import NxtCircularLoader from 'components/nxt_circular_loader/View';
import DraftIdeaCard from './draft_idea_card/View';
import navigation from '../../support/navigation';



const StatusFilterButtons = ({ statusOptions, statusFilter, setStatusFilter }) => (
  <div style={{ marginBottom: '16px' }}>  
    <p>My Idea Filter:</p>
    {statusOptions.map(status => (
      <button
        type="button"
        key={status}
        onClick={() => setStatusFilter(status)}
        style={{
          marginRight: '10px',
          padding: '6px 12px',
          backgroundColor: statusFilter === status ? '#007bff' : '#f0f0f0',
          color: statusFilter === status ? '#fff' : '#000',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        {status}
      </button>
    ))}
  </div>
);



// const getFilteredIdeas = (ideas, statusFilter) => {
//   return (ideas ?? []).filter(
//     idea => idea?.status?.toLowerCase() === statusFilter.toLowerCase()
//   );
// };



const getFilteredIdeas = (ideas, statusFilter) => {
  const list = ideas ?? [];
  const isDraftView = statusFilter?.toLowerCase() === "draft";

  return isDraftView
    ? list.filter(i => i?.status?.toLowerCase() === "draft")
    : list.filter(i => i?.status?.toLowerCase() !== 'draft');
};




const IdeaCards = ({ ideas, onDeleteClick, redirectIdeaURL,classes }) => {
  // if (!ideas.length) return renderEmptyState();

  return (
    <div className={classes.IdeaGrid}>
      {ideas.map(idea => {
        const isDraft = idea?.status === 'DRAFT';

        return isDraft ? (
          <DraftIdeaCard
            key={idea.id}
            idea={idea}
            handleDelete={() => onDeleteClick(idea.id)}
            handleContinue={() => redirectIdeaURL(idea)}
          />
        ) : (
          <IdeaPanel
            key={idea.id}
            idea={idea}
            isInnovate={idea?.isInnovate}
            urlId={idea.id}
          />
        );
      })}
    </div>
  );
};



const MyIdeas = ({
  classes,
  userIdeas,
  getMyIdeas,
  navigateToIdea,
  onDeleteClick,
  isIdeasLoading,
  navigateToInnovateIdea,
  isHackathonEnable,
  getInnovateMyIdeas,
  innovateMyIdeaIsLoading,
  innovateMyIdeaList,
}) => {
  const [showDrafts, setShowDrafts] = useState(false);

  const statusOptions = ['Active', 'DRAFT'];
  const [statusFilter, setStatusFilter] = useState('Active');


    useEffect(() => {
    if (isHackathonEnable) {
      getInnovateMyIdeas();
    }else{
      getMyIdeas();
    }
  }, [isHackathonEnable]);
  
  // useEffect(() => {
  //   getMyIdeas();
  // }, []);

  // useEffect(() => {
  //   if (isHackathonEnable) {
  //     getInnovateMyIdeas();
  //   }
  // }, [isHackathonEnable]);


  const draftIdeas = useMemo(
    () => userIdeas.filter(idea => idea.status === statusConstants.DRAFT),
    [userIdeas]
  );

  const publishedIdeas = useMemo(
    () => userIdeas.filter(idea => idea.status !== statusConstants.DRAFT),
    [userIdeas]
  );


const renderEmptyState = () => (
  <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
    <img className={classes.noIdeaImg} src={noIdeasImg} alt="no idea found" />
    <p className={classes.noIdeas}>
      No existing <span className={classes.purpleNo}>ideas</span>
    </p>
  </div>
);

  // with isHackthon

  //   const draftIdeas = useMemo(() =>
  //   userIdeas.filter(idea =>
  //     idea.status === statusConstants.DRAFT &&
  //     (isHackathonEnable ? idea.isInnovate === true : !idea.isInnovate)
  //   ),
  //   [userIdeas, isHackathonEnable]
  // );

  // const publishedIdeas = useMemo(() =>
  //   userIdeas.filter(idea =>
  //     idea.status !== statusConstants.DRAFT &&
  //     (isHackathonEnable ? idea.isInnovate === true : !idea.isInnovate)
  //   ),
  //   [userIdeas, isHackathonEnable]
  // );

  const pageHierarchy = [
    { string: 'Home', navigate: () => navigation.navigateToExplore() },
    { string: 'My ideas', navigate: () => { } }
  ];



  const redirectIdeaURL = idea => {
    if (idea?.isInnovate) {
      navigateToInnovateIdea(idea.id);
    } else {
      navigateToIdea(idea.id);
    }
  };


  //   <div className={classes.IdeaGridDraft}>
  //   {innovateMyIdeaList?.map(idea => (
  //   <DraftIdeaCard
  //   key={idea.id}
  //   idea={idea}
  //   handleDelete={() => onDeleteClick(idea.id)}
  //   handleContinue={() => redirectIdeaURL(idea)}
  // />
  //   ))}
  //      </div>

  // const statusOptions = ['Active', 'Draft'];
  // const filteredMyIdea = (innovateMyIdeaList ?? []).filter(
  //   myidea => myidea?.status?.toLowerCase() === statusFilter.toLowerCase()
  // );
  // console.log("🚀 ~ filteredMyIdea:", filteredMyIdea)



 const listmyIdea = innovateMyIdeaList?.data || []
//  const listmyIdea = innovateMyIdeaList

const sortedFiltered = React.useMemo(() => {
  return [...listmyIdea].sort((a, b) => {
    const aSelected = a.status === "SELECTED_FOR_HACKATHON";
    const bSelected = b.status === "SELECTED_FOR_HACKATHON";

    // Get timestamps for comparison
    const aTimestamp = a.created?.timestamp || a.created || 0;
    const bTimestamp = b.created?.timestamp || b.created || 0;

    // If selection status differs, selected items come first
    if (aSelected !== bSelected) {
      return bSelected - aSelected; // true (1) - false (0) = 1, so selected comes first
    }

    // If same selection status, sort by date (newest first)
    return bTimestamp - aTimestamp;
  });
}, [listmyIdea]); 


const filteredMyIdea = getFilteredIdeas(sortedFiltered, statusFilter);

  return (
    <>
      <Breadcrumbs crumbs={pageHierarchy} />
      
      <Container>
      <section className='notice-maintaince'>
            <h3 style={{margin:'0px'}}>Scheduled Maintenance Notice</h3>
            <p>We are currently undergoing planned maintenance and migration. During this time, some ideas may not appear on the platform. We are working to restore full functionality as quickly as possible. All other functionality is working as usual. You can submit an idea by clicking the Post an Idea button.</p>
            <p style={{margin:"0px"}}><b>Thank you for your patience and understanding.</b></p>
          </section>
        {
          isHackathonEnable ? (           
            
          
                
                  <NxtCircularLoader isLoading={innovateMyIdeaIsLoading}>
                    <StatusFilterButtons
                      statusOptions={statusOptions}
                      statusFilter={statusFilter}
                      setStatusFilter={setStatusFilter}
                    />
         
                    {filteredMyIdea?.length === 0 ? renderEmptyState() :
                    <IdeaCards
                      ideas={filteredMyIdea}
                      onDeleteClick={onDeleteClick}
                      redirectIdeaURL={redirectIdeaURL}
                    classes={classes}
                    />
         }        </NxtCircularLoader>
         
          )

            :

            <NxtCircularLoader isLoading={isIdeasLoading}>
              <main className={classes.background}>
                <div className={classes.top_section_text}>
                  <div className={classes.title}>
                    {showDrafts
                      ? `Draft ideas (${draftIdeas.length})`
                      : `My ideas (${publishedIdeas.length})`}
                  </div>
                  <button
                    type="button"
                    className={classes.investedIdeasNumber}
                    onClick={() => setShowDrafts(prev => !prev)}
                  >
                    {showDrafts
                      ? `My ideas (${publishedIdeas.length})`
                      : `Draft ideas (${draftIdeas.length})`}
                  </button>
                </div>

                {showDrafts && (
                  draftIdeas.length === 0
                    ? renderEmptyState()
                    : (
                      <div className={classes.IdeaGridDraft}>
                        {draftIdeas.map(idea => (
                          <DraftIdeaCard
                            key={idea.id}
                            idea={idea}
                            handleDelete={() => onDeleteClick(idea.id)}
                            handleContinue={() => redirectIdeaURL(idea)}
                          />
                        ))}
                      </div>
                    )
                )}

                {!showDrafts && (
                  publishedIdeas.length === 0
                    ? renderEmptyState()
                    : (
                      <div className={classes.IdeaGrid}>
                        {publishedIdeas.map(idea => (
                          <IdeaPanel key={idea.id} idea={idea} isInnovate={idea?.isInnovate} urlId={idea.id} />
                        ))}
                      </div>
                    )
                )}

              </main>
            </NxtCircularLoader>

        }


      </Container>
    </>
  );
};

export default withStyles(styles)(MyIdeas);
